import { render } from "./bargain_goods.vue?vue&type=template&id=3f07fbfe&scoped=true&ts=true"
import script from "./bargain_goods.vue?vue&type=script&lang=ts"
export * from "./bargain_goods.vue?vue&type=script&lang=ts"

import "./bargain_goods.vue?vue&type=style&index=0&id=3f07fbfe&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f07fbfe"]])

export default __exports__